import React, { Component } from 'react'

import { EditableSelect } from '../../common/EditableComponents'
import { MenuItem } from '@material-ui/core'

export const MCComplianceCatDropdownComponent = (props) => {
  const { value } = props

  var dataOptions = props.getDataOptions()
  const fieldName = 'key'

  let displayValue = (dataOptions[value] && dataOptions[value][fieldName]) || value
  return (
    <div className="center-item-column">
      <div
        className="align-item-column-value"
        style={{ overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}
        title={displayValue}
      >
        {displayValue}
      </div>
    </div>
  )
}

export class MCComplianceCatDropdownEditor extends Component {
  state = { value: this.props.value }

  handleChange = (event) => {
    let value = event.target.value
    if (this.props.multiple) {
      value = value.filter(function (el) {
        return el
      })
    }
    this.setState({ value })
  }
  afterGuiAttached = () => {}
  getValue = () => this.state.value
  destroy = () => {}

  render() {
    const { value } = this.state
    const { data } = this.props

    const options = this.props.getDataOptionsList(data.shopId)
    
    return (
      <div className="center-item-column">
        <div className="align-item-column-value">
          <EditableSelect
            editMode={true}
            material={false}
            name={this.props.colDef.field}
            onChange={(event) => this.handleChange(event)}
            value={value}
            valueToRender={value}
          >
            {options.length > 0 ? (
              options.map((entry, index) => {
                return (
                  <MenuItem key={index} value={entry.id}>
                    {entry.key}
                  </MenuItem>
                )
              })
            ) : (
              <MenuItem value="" disabled>
                <em>There are no compliance categories for this shop.</em>{' '}
              </MenuItem>
            )}
          </EditableSelect>
        </div>
      </div>
    )
  }
}

export default {
  MCComplianceCatDropdownComponent,
  MCComplianceCatDropdownEditor,
}



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Components/MCComplianceCatDropdownComponent.js